<template>
  <div class="no-access">
    <div class="no-access-card">
      <h1 class="no-access-title">No Access</h1>
      <p class="no-access-message">
        Your account doesn't have access to any areas of the portal yet.
        Please contact your administrator if you believe this is an error.
      </p>
      <router-link to="/logout" class="no-access-link">Sign out</router-link>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.no-access {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  padding: 24px;
}

.no-access-card {
  max-width: 480px;
  text-align: center;
}

.no-access-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px;
}

.no-access-message {
  font-size: 15px;
  color: #555;
  line-height: 1.5;
  margin: 0 0 20px;
}

.no-access-link {
  display: inline-block;
  padding: 8px 18px;
  background: #000;
  color: #fff;
  border-radius: 4px;
  text-decoration: none;
  font-size: 14px;
}

.no-access-link:hover {
  background: #333;
}
</style>
